export default __webpack_public_path__ + "static/media/100_19067.49369036.jpg";